<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
  <h5 class="mb-0"> {{'Plants_list' | translate}} </h5>
  <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
    <li class="breadcrumb-item position-relative" routerLink="/">{{'Dashboard'| translate}}</li>
    <li class="breadcrumb-item position-relative">{{'Plants_list' | translate}}</li>
  </ol>
</div>

<mat-card class="daxa-card users-card mb-25 border-radius bg-white border-none d-block">
  <mat-card-header>
    <mat-card-title>
      <app-search-input-with-debouncing (searchEvent)="onSearch($event)" placeholder="Search">
      </app-search-input-with-debouncing>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="users-table">
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

          <!-- Column: col1 -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Id' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row?.id }}</td>
          </ng-container>

          <!-- Column: col2 -->
          <ng-container matColumnDef="plantOwner">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Plant_owner' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row?.plantOwner }}</td>
          </ng-container>
          <!-- Column: col3 -->
          <ng-container matColumnDef="cityName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'City_name' | translate}}</th>
            <td mat-cell *matCellDef="let row"> {{ row?.cityName }}</td>
          </ng-container>
          <!-- Column: col4 -->
          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Username' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row?.userName }}</td>
          </ng-container>
          <!-- Column: col5 -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Email' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row?.email }}</td>
          </ng-container>
          <!-- Column: col6 -->
          <ng-container matColumnDef="phoneNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Phone_number' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row?.phoneNumber }}</td>
          </ng-container>
          <!-- Column: col7 -->
          <ng-container matColumnDef="customerType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Customer_type' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row?.customerType }}</td>
          </ng-container>
          <!-- Column: col8 -->
          <ng-container matColumnDef="disabled">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Status' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-chip" [class.active]="!row?.disabled" [class.inactive]="row?.disabled">
                <mat-icon>
                  {{ row?.disabled ? 'toggle_off' : 'toggle_on' }}
                </mat-icon>
                {{ row?.disabled ? ('Inactive' | translate) : ('Active' | translate) }}
              </span>
            </td>
          </ng-container>

          <!-- Offline inverter status (GetPlants.hasOfflineDevices) -->
          <ng-container matColumnDef="hasOfflineDevices">
            <th mat-header-cell *matHeaderCellDef>{{ 'Has_offline_inverter' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <span class="inverter-connectivity"
                    [class.inverter-connectivity--offline]="row.hasOfflineDevices"
                    [class.inverter-connectivity--online]="!row.hasOfflineDevices"
                    cdkOverlayOrigin #connectivityOrigin="cdkOverlayOrigin"
                    tabindex="0"
                    [attr.aria-label]="offlineTooltip(row)"
                    [attr.aria-expanded]="activeConnectivityPlantId === row.id"
                    (mouseenter)="showConnectivityDetails(row)"
                    (mouseleave)="hideConnectivityDetails(row)"
                    (focus)="showConnectivityDetails(row)"
                    (blur)="hideConnectivityDetails(row)"
                    (keydown.escape)="hideConnectivityDetails(row)">
                <mat-icon aria-hidden="true">{{ row.hasOfflineDevices ? 'error_outline' : 'check_circle_outline' }}</mat-icon>
                <span>{{ (row.hasOfflineDevices ? 'Offline_detected' : 'All_online') | translate }}</span>
              </span>

              <ng-template cdkConnectedOverlay
                           [cdkConnectedOverlayOrigin]="connectivityOrigin"
                           [cdkConnectedOverlayOpen]="activeConnectivityPlantId === row.id"
                           [cdkConnectedOverlayPositions]="connectivityOverlayPositions"
                           [cdkConnectedOverlayPush]="true">
                <section class="inverter-detail-card"
                         [class.inverter-detail-card--online]="!row.hasOfflineDevices"
                         role="status">
                  <div class="inverter-detail-card__heading">
                    <span class="inverter-detail-card__icon" aria-hidden="true">
                      <mat-icon>{{ row.hasOfflineDevices ? 'error_outline' : 'check_circle_outline' }}</mat-icon>
                    </span>
                    <div class="inverter-detail-card__headings">
                      <strong>{{ (row.hasOfflineDevices ? 'Offline_inverter' : 'All_inverters_online') | translate }}</strong>
                      <small>{{ (row.hasOfflineDevices ? 'Connection_issue_detected' : 'All_devices_are_connected') | translate }}</small>
                    </div>
                  </div>
                  <div class="inverter-detail-card__body" *ngIf="row.hasOfflineDevices">
                    <ng-container *ngIf="offlineDetailsLoading; else offlineLoaded">
                      <p class="inverter-detail-card__message">{{ 'Loading_inverter_details' | translate }}</p>
                    </ng-container>
                    <ng-template #offlineLoaded>
                      <ng-container *ngIf="offlineInverterSerials(row.id).length; else noSerials">
                        <div class="inverter-detail-card__section-label">{{ 'Serial_number' | translate }}</div>
                        <div class="inverter-detail-card__serial" *ngFor="let serial of offlineInverterSerials(row.id)">
                          <mat-icon aria-hidden="true">memory</mat-icon>
                          <span>{{ serial }}</span>
                          <span class="inverter-detail-card__dot" [attr.aria-label]="'Offline' | translate"></span>
                        </div>
                      </ng-container>
                      <ng-template #noSerials>
                        <p class="inverter-detail-card__message">{{ (offlineDetailsUnavailable ? 'Inverter_details_unavailable' : 'No_serial_numbers_available') | translate }}</p>
                      </ng-template>
                    </ng-template>
                  </div>
                </section>
              </ng-template>
            </td>
          </ng-container>

          <!-- Action -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{'Action' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <div class="action-info">
                <button mat-button class="daxa" matTooltip="{{'View' | translate}}" (click)="onView(row)">
                  <i class="material-symbols-outlined">visibility</i>
                </button>
                <button mat-button class="daxa" matTooltip="{{'Edit' | translate}}" (click)="onEdit(row)">
                  <i class="material-symbols-outlined">edit</i>
                </button>
                <button mat-button class="daxa" matTooltip="{{'add_inverter' | translate}}" (click)="onAddInverter(row)">
                  <i class="material-symbols-outlined">Add</i>
                </button>
                <button mat-button class="daxa" matTooltip="{{'delete' | translate}}" (click)="onDelete(row)">
                  <i class="material-symbols-outlined">delete</i>
                </button>
                <button
                  mat-button
                  class="daxa"
                  [matTooltip]="(row?.disabled ? 'Enable' : 'Disable') | translate"
                  [disabled]="toggleBusyIds.has(row.id)"
                  (click)="onToggleDisablePlant(row)">
                  <i *ngIf="!toggleBusyIds.has(row.id)"
                     class="material-symbols-outlined toggle-icon"
                     [class.toggle-icon--on]="!row?.disabled"
                     [class.toggle-icon--off]="row?.disabled">
                    {{ row?.disabled ? 'toggle_off' : 'toggle_on' }}
                  </i>
                  <i *ngIf="toggleBusyIds.has(row.id)" class="material-symbols-outlined toggle-spinner">autorenew</i>
                </button>
              </div>
            </td>
          </ng-container>

          <!-- Header / Rows -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <!-- Empty / Loading Row -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
              <ng-container *ngIf="isLoading; else noDataTpl">
                <app-buffer-progress-bar></app-buffer-progress-bar>
              </ng-container>
              <ng-template #noDataTpl> No data found </ng-template>
            </td>
          </tr>
        </table>
      </div>
      <mat-paginator [pageSizeOptions]="[8, 20, 30]" [pageSize]="8" [length]="total" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>